export const RESET = 'EXCMRELATIONUSERDATA_LIST_RESET'
export const SET_ITEMS = 'EXCMRELATIONUSERDATA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMRELATIONUSERDATA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMRELATIONUSERDATA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMRELATIONUSERDATA_LIST_TOGGLE_LOADING'
